import { useEnums } from '../hooks/useEnums';

export const HumanReadableEnumValue = (props) => {
    const { getHumanReadableValue } = useEnums();

    return getHumanReadableValue(props.enumType, props.value);
};
